import { Container as UnstatedContainer } from 'unstated';
import myGlobals from '../Utils/globals';
import { store as reduxStore } from "../redux/store";
import { callReduxAlertAction, callReduxConfirmAlertAction } from '../App';
import { hideConfirmAlertAction } from '../redux/actions/alertConfirmAction';
import { CANADA_COUNTRY_CODE, PaymentStatuses } from '../Utils/utils';
import { myUtilities } from '../Utils';
class PaymentDataContainer extends UnstatedContainer {
  state = {
    bankAccNo:null,
    bankName: null,
    countryCode: '',
    routingNo: null,
    accountName:"",
    pkMcarId: null,
    accountId:null,
    invoices:null,
    currency:null,
    accountType: 'Savings',
    loadingPaymentStatus: false,
    paymentStatusCompleted: false,
    paymentStatus: null,
    showToast: false,
    formRef: null,
    allowSubmit: false,
    creditCardCheck: false,
    splitId: null,
    paymentId: null,
    totalConvienceFee: null,
    totalSurchargeAmount: null,
    isDCFlow: false,
    cardType: '',
    transactionID : '',
    financialInstituteNumber: "",
    transitNumber: "",
    totalLateFee: null,
    achMandateFields: null,
  }
  
  getCurrentCountryCode = () => {
    return this.state.countryCode;
  };
  setFinancialInstituteNumber = (financialInstituteNumber, financialInstitutionDetails) => {

    let valueToBeSet = "";

    if (financialInstitutionDetails === undefined || 
      typeof financialInstitutionDetails !== 'object' || 
      financialInstitutionDetails[financialInstituteNumber] === undefined)
      valueToBeSet = ""
    else
      valueToBeSet = financialInstitutionDetails[financialInstituteNumber][0];

    this.setState({
      financialInstituteNumber: valueToBeSet
    })

  };
  populateFormData = () => {
    this.setState({

    });
  }
  setTotalConvenienceFee = async (number) => {
    await this.setState({
      totalConvienceFee: number
    });
  }
  setTotalConvenienceFeeAndSurcharge = async (convenienceFee,surchargeAmount) => {
    await this.setState({
      totalConvienceFee: convenienceFee,
      totalSurchargeAmount: surchargeAmount
    });
  }
  
  setTotalLateFee = async (totalLateFee) => {
    await this.setState({
      totalLateFee: totalLateFee
    });
  }
  
  setTotalSurchargeAmount = async (number) => {
    await this.setState({
      totalSurchargeAmount: number
    });
  }
  setCreditCardCheck = async (bool) => {
    await this.setState({
      creditCardCheck:bool
    });
  }
  isDCFlow = async (bool) => {
  myGlobals.isDCFlow = bool;
    await this.setState({
      isDCFlow:bool
    });
  }
  setAlertShow = (bool) => {
    this.setState({
      showToast:bool
    });
  }
  setPaymentData = async (paymentId, splitIdString, transactionID = '') => {
    await this.setState({
          paymentId: paymentId, 
          splitId: splitIdString,
          loadingPaymentStatus: false,
          paymentStatusCompleted:true,
          paymentStatus:true,
          transactionID: transactionID
    });
  }
  setPaymentFailed = async () => {
    this.setState({
          loadingPaymentStatus: false,
          paymentStatusCompleted:true,
          paymentStatus:false
    });
  }
  setAllowSubmit = async (bool) => {
    await this.setState({
      allowSubmit:bool,
      formRef: false
    });

  }
  setFormRef = (obj) => {
    this.setState({
      formRef:obj
    });
  }

  setACHMandateFields = (achMandateFields) => {
    this.setState({
      achMandateFields: achMandateFields
    });
  }

  setDataForSendingOldACH = (data) => {
     const dataToBePassed = {
      bankName: this.state.bankName,
      acctHolderName: this.state.accountName,
      routingNum: this.state.routingNo,
      bankAcctNum: this.state.bankAccNo,
      acctType: this.state.accountType,
      countryCode:this.state.countryCode,
      transitNumber: this.state.transitNumber,
      financialInstituteNumber: this.state.financialInstituteNumber,
      achMandateFields: this.state.achMandateFields
    };

    if (this.state.countryCode === CANADA_COUNTRY_CODE &&
      (dataToBePassed.financialInstituteNumber === undefined || dataToBePassed.financialInstituteNumber === "")) {
      callReduxAlertAction(
        "generic.pte.invalidForm.financialInstituteNumber",
        "Please select valid Financial Institute Number from the dropdown"
      );
      return;
    }

    myGlobals.setDataForSendingOldACHdata = data;
    myGlobals.setDataForSendingOldACHdataToBePassed = dataToBePassed;
    console.log("achMandateFields -> ", dataToBePassed.achMandateFields);
    
    myGlobals.handleConfirmClick = () => {
      reduxStore.dispatch(hideConfirmAlertAction());
      myGlobals.processPartialInvoices = true;
      this.setDataForSending(myGlobals.setDataForSendingOldACHdata, 
        myGlobals.setDataForSendingOldACHdataToBePassed);   
    };

    this.setDataForSending(data, dataToBePassed);
  }
  setDataForSending = (data, dataToBePassed) => {
    this.setState({
      loadingPaymentStatus: true,
    });
    let remittanceFormData = data.state.remittanceFormData;
    let requestMap = new Map();
    if(data.state.paymentOnAccount){
      console.log("customerId : " + data.state.pkMcarId);
      requestMap.set('supplierId',window.rsaEncrypt(data.state.onDemandAccountId));
      requestMap.set('payThroughEmail',window.rsaEncrypt(true));
      requestMap.set('customerMapId',window.rsaEncrypt(data.state.pkMcarId));
      requestMap.set('accountHolderName',window.rsaEncrypt(dataToBePassed.acctHolderName));
      requestMap.set('accountNumber',window.rsaEncrypt(dataToBePassed.bankAcctNum));
      requestMap.set('bankName',window.rsaEncrypt(dataToBePassed.bankName));
      requestMap.set('accountType',window.rsaEncrypt(dataToBePassed.acctType));
      requestMap.set('saveBankAccountForReuse',window.rsaEncrypt(false));
      requestMap.set('countryCode',window.rsaEncrypt(dataToBePassed.countryCode));
      requestMap.set('routingNumber',window.rsaEncrypt(dataToBePassed.routingNum));
      requestMap.set('isSupplier',window.rsaEncrypt(false));
      requestMap.set('totalAmount',window.rsaEncrypt(data.state.payableAmount));
      requestMap.set('currency',window.rsaEncrypt(data.state.currency));
      requestMap.set('token',encodeURIComponent(myGlobals.token));
      if(remittanceFormData!==null){
        const keys = Object.keys(remittanceFormData);
        for(let i=0;i<keys.length;++i){
          requestMap.set(keys[i],window.rsaEncrypt(remittanceFormData[keys[i]]));
        }
      }
    }
    else{
      let invoices = data.state.selectedInvoices;
      let invoiceList = invoices.map((invoice)=>
        invoice.accountDocHeaderId+'@'+invoice.payableAmount2+'@'+invoice.disputeAmount+'@'+invoice.reasonCodeId
      )
      let currency = invoices[0].currency;
      requestMap.set('invoiceNumbers',(invoiceList));
      requestMap.set("processPartialInvoices", window.rsaEncrypt(myGlobals.processPartialInvoices));
      requestMap.set('onDemandAccountId',window.rsaEncrypt(data.state.onDemandAccountId));
      requestMap.set('pkMapCustomerAccountRad',window.rsaEncrypt(data.state.pkMcarId));
      requestMap.set('globalAccountId',window.rsaEncrypt(data.state.globalAccountId));
      requestMap.set('currency',window.rsaEncrypt(currency));
      requestMap.set('accountHolderName',window.rsaEncrypt(dataToBePassed.acctHolderName));
      requestMap.set('accountNo',window.rsaEncrypt(dataToBePassed.bankAcctNum));
      requestMap.set('accountType',window.rsaEncrypt(dataToBePassed.acctType));
      requestMap.set('routingNo',window.rsaEncrypt(dataToBePassed.routingNum));
      requestMap.set('token',window.rsaEncrypt(data.state.token));
      requestMap.set('bankName',window.rsaEncrypt(dataToBePassed.bankName));
      requestMap.set('countryCode',window.rsaEncrypt(dataToBePassed.countryCode));
      requestMap.set('publicKey',(data.state.publicKey));
    }

    console.log("achMandateFields in request -> " + dataToBePassed.achMandateFields);
    if (null != dataToBePassed.achMandateFields) {
      let achMandateFieldsJSONString = JSON.stringify(dataToBePassed.achMandateFields);
      console.log("achMandateFieldsJSONString -> " + achMandateFieldsJSONString);
      requestMap.set('achMandateFields', window.rsaEncrypt(achMandateFieldsJSONString));
    }

    if(dataToBePassed.transitNumber != undefined) {
      requestMap.set("transitNumber", window.rsaEncrypt(dataToBePassed.transitNumber));
    } else {
      requestMap.set("transitNumber", null)
    }

    if(dataToBePassed.transitNumber != undefined) {
      requestMap.set("financialInstituteNumber", window.rsaEncrypt(dataToBePassed.financialInstituteNumber));
    } else {
      requestMap.set("financialInstituteNumber", null);
    }

    this.sendData(data,requestMap,
      async (data)=>{
        // let splitIdSet = new Set();
        // let splitIdString = '';
        // for(let i=0;i<data.rows.length;++i){
        //   if(null!==data.rows[i].splitId && undefined!==data.rows[i].splitId)
        //     splitIdSet.add(data.rows[i].splitId);
        // }
        // if(splitIdString.localeCompare('')===0){
        //   if(null!==data.rows[0].splitPaymentId && undefined!==data.rows[0].splitPaymentId)
        //     splitIdSet.add(data.rows[0].splitPaymentId);
        // }
        // splitIdSet.forEach((splitId)=>{
        //   splitIdString+=splitId+',';
        // });
        // splitIdString=splitIdString.substring(0,splitIdString.length-1);

      
          await this.setPaymentData(data.rows.paymentId, data.rows.splitIds, data.rows.transactionID);
          myGlobals.ACHPaymentCompleted = true;
          myGlobals.getHistory.replace(`/completepaymentACH`);
        
      },
      (data)=>{
        myGlobals.getHistory.replace(`/paymentfailed`);
      }
    )
  }
  sendData = (invData,obj,onSuccess,onFailure) => {
    let myBody = '';
    let link;
    let self = this;
    if(obj.get('payThroughEmail')===undefined)
      link = 'payForInvoicesViaACH';
    else
      link = 'invokeACHPaymentOnAccountWithoutLogin';
    let keys = [...obj.keys()]
    keys.forEach((item,index)=>{
      myBody+=item+'='+obj.get(item)+'&';
    })
    myBody = myBody.substring(0,myBody.length-1);
    link = myGlobals.initialHost+myGlobals.appender+link
    fetch(link, {
    //fetch("https://api.jsonbin.io/b/5ee7238b0e966a7aa369a22b", {

      method: 'POST',
          headers: {
              
              'Content-Type': 'application/x-www-form-urlencoded',
          },
      body: myBody

    }).then(
      function(response){
        if (response.status !== 200) {
          console.log('Looks like there was a problem. Status Code: ' +
            response.status);
          return;
        }
        return response.json();
      }
    ).then(function(data){

      if(data != undefined && data.rows != undefined && data.rows.failureReason && data.rows.failureReason === 'LINK_EXPIRED'){
        myGlobals.errorMessage = myUtilities.accountSpecificLanguage("Error.LinkExpired", "Link has expired");
        myGlobals.getHistory.replace(`/linkExpired`);
        return;
      }

      if(data===undefined || data.rows.paymentStatus == 'Failure' || data.rows.paymentStatus == 'Failed'){
        onFailure(data);
      } else if(data.rows.paymentStatus !== undefined && String(data.rows.paymentStatus).toLowerCase() === PaymentStatuses.IN_PROGRESS_STATUS) {
        data.rows.paymentType = 'ACH';
        window.inProgressPayment(data.rows) ;
      }   
      else if(data===undefined || (myGlobals.currentTheme !== undefined && myGlobals.currentTheme == 'modernUX.css') ? data.rows[0].paymentResponseMessage == 'InvalidRoutingNumber' : data.rows.paymentResponseMessage == 'InvalidRoutingNumber'){
      	myGlobals.setInvalidRoutingNumber();
        myGlobals.invalidRoutingNumberMessage = true;
        onFailure(data);
      } else if (data && data.rows.paymentResponseMessage === "GP_ACH_FAILURE_GIACT") {
        callReduxAlertAction(
          "Alert.GP_ACH_FAILURE_GIACT",
          "Account verification failed. Please check the bank account."
        );
        self.setState({loadingPaymentStatus: false});
        invData.setState({ resetNum: invData.state.resetNum + 1 }); // to re-ender components from form
        self.setState({
          bankName: "",
          acctHolderName: "",
          routingNum: "",
          bankAcctNum: "",
        });

      } else if(data && data.rows.paymentResponseMessage === "PROCESS_PARTIAL_INVOICES") {
        self.setState({loadingPaymentStatus: false});
        myGlobals.flowName="PROCESS_PARTIAL_INVOICES";
        callReduxConfirmAlertAction(
          "Alert.PROCESS_PARTIAL_INVOICES",
          "Some of the invoices cannot be processed. Do you want to continue?"
        );
      }
      else{
        onSuccess(data);
      }
    }).catch(
      function(err)
      {
        console.log('Fetch Error :-S',err);
        onFailure(err);
      }
    );
  }
  getFormData = () => {
    return this.state;
  }
  populateInputData = (index,val) => {
    let temp = JSON.parse(JSON.stringify(this.state));
    temp[index]=val;
    this.setState(temp);
  }
  setCardType = async cardType => await this.setState({cardType: cardType});
  resetCardType = async () => await this.setState({cardType: ''});
}

export default PaymentDataContainer;
